"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQuestionData = exports.validateQuestionData = void 0;
const i18next_1 = __importDefault(require("i18next"));
const validateQuestionData = ({ is_question, questions, }) => {
    let validation;
    if (is_question) {
        questions.forEach(data => {
            if (!data.content) {
                validation = i18next_1.default.t('질문을 입력해주세요');
                return false;
            }
        });
    }
    return validation;
};
exports.validateQuestionData = validateQuestionData;
const generateQuestionData = ({ is_question, questions, delete_questions, }) => {
    let questionDataObj = { is_question };
    if (is_question) {
        Object.assign(questionDataObj, { questions });
        if (delete_questions.length) {
            Object.assign(questionDataObj, { delete_questions });
        }
    }
    return questionDataObj;
};
exports.generateQuestionData = generateQuestionData;
